// extracted by mini-css-extract-plugin
export var auto = "_2z-1";
export var spinner = "_2z-0";